export enum LotteryStatuses {
  LOADING,
  LOADED,
}
